
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSourceDataReviewAudit, GetSourceDataReviewAuditResponse, GetTrialSourceDataFindings } from "@/api/dtos";
import useGet from "@/hooks/api/useGet";
import { useMemo } from "react";

const getData = (response?: SWRResponse<GetSourceDataReviewAuditResponse, GetSourceDataReviewAuditResponse>) => response?.data?.audit;
const getError = (response?: SWRResponse<GetSourceDataReviewAuditResponse, GetSourceDataReviewAuditResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetSourceDataReviewAuditResponse, GetSourceDataReviewAuditResponse>) => ({});

export const useParticipantSourceDataReviewAudit = (
    trialId?: number,
    participantId?: number,
    studyEventOid?: string,
    studyEventRepeat?: number,
    caseReportFormOid?: string,
    itemGroupName?: string,
    itemGroupRepeat?: number,
    itemName?: string,
    configuration?: SWRConfiguration | undefined
) => {
    const request = useMemo(() => {
        if (
            !trialId || 
            !participantId || 
            !studyEventOid || 
            !studyEventRepeat || 
            !caseReportFormOid || 
            !itemName
        ) {
            return undefined;
        }

        return () => {
            return new GetSourceDataReviewAudit({ 
                trialId,
                participantId,
                studyEventOid,
                studyEventRepeat,
                caseReportFormOid,
                itemGroupName,
                itemGroupRepeat: itemGroupRepeat ?? 1,
                itemName
            });
        }
    }, [
        trialId,
        participantId,
        studyEventOid,
        studyEventRepeat,
        caseReportFormOid,
        itemGroupName,
        itemGroupRepeat,
        itemName
    ]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useParticipantSourceDataReviewAudit;